module.exports = __webpack_public_path__ + "img/CV.Drainage.Gullies.PE_Gully.a53fd721.png";